import { useEffect } from 'react'

import type { TemplateVersion } from '../types/templateModel'
import { useTemplateVersion } from '../uiModels/useTemplateVersion'
import { useTemplateVersionInfo } from '../uiModels/versionInfo/useTemplateVersionInfo'
import { useConfigurationContext } from './configurationContext'

type Props = {
  templateId: string
  onRegisterVersion: (templateVersion: TemplateVersion) => void
}

/**
 * Component responsible for registering a referenced template version in the TemplateProvider.
 * These registered versions are used inside diagrams.
 */
export const ReferencedTemplateVersionRegistrator = ({
  templateId,
  onRegisterVersion,
}: Props) => {
  const { viewAt } = useConfigurationContext()
  const versionInfo = useTemplateVersionInfo({
    id: templateId,
    date: viewAt,
  })

  const templateVersionForDate = useTemplateVersion({
    versionInfo,
    // References don't care about being flattened.
    isFlattened: false,
  })

  useEffect(
    function registerActiveTemplateVersion() {
      if (templateVersionForDate) {
        onRegisterVersion(templateVersionForDate)
      }
    },
    [onRegisterVersion, templateVersionForDate],
  )

  return null
}
